import { createContext, useContext } from 'react';

const ServerSideContext = /*#__PURE__*/createContext(undefined);

/**
 * utility component to apply a specific status code while performing server
 * side rendering.
 */
function HttpStatus(props) {
  const serverSideContext = useContext(ServerSideContext);
  if (serverSideContext) {
    serverSideContext.statusCode = props.code;
  }
  return null;
}

/**
 * determines if the application is currently running on the server side layer
 */
function useIsServerSide() {
  return useContext(ServerSideContext) !== undefined;
}

export { HttpStatus, ServerSideContext, useIsServerSide };
//# sourceMappingURL=context.server-side.js.map
